<template>
  <div
    v-if="activeUserInfo"
    class="the-navbar__user-meta flex items-center"
  >
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer"
    >
      <vs-button type="border">
        {{ activeUserInfo }}
      </vs-button>
      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="onLogoutClick"
          >
            <VueFeather
              type="log-out"
              class="feather-icon feather-icon-css-target inline-flex"
            />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  computed: {
    activeUserInfo () {
      return this.$store.state.auth.activeUser
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    async onLogoutClick () {
      await this.logout()
      await this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.feather-icon-css-target :deep(.vue-feather__content) {
  width: 1rem !important;
  height: 1rem !important;
}
</style>
